import React from "react";
import { inject, observer } from "mobx-react";
import { Button, Input, Modal, Radio, Select, Spin } from "antd";
import commissions from "@services/commissions";
import mentors from "@services/mentors";
import { alertPopup } from "@utils/popup";

@inject(({ popupStore }) => ({ popupStore }))
@observer
class OneTimeMentorCommission extends React.Component {
    constructor (props) {
        super (props)
        this.state = {
            loadingMentors: false,
            loadingSubmit: false,
            
            mentors: [],
            selectedMentor: {},

            balance: 'CREDIT',
            amount: null,
            year: new Date().getFullYear() - 2000,
            month: new Date().getMonth() + 1,
            comment: ''
        }
    }

    componentDidMount(): void {
        this.getMentors()
    }

    toggleBalance = ({ target: { value } }) => {
        this.setState({ balance: value ? 'CREDIT' : 'DEBT' })
    }

    getMentors = () => {
        this.setState({ loadingMentors: true }, () => {
            mentors.getAllMentors()
            .then((res) => {
                this.setState({ mentors: res.data })
            })
            .catch((error) => {
                console.log('error', error);
                alertPopup({ type: 'error', title: 'אירעה שגיאה בעת טעינת מנטורים', body: '' })
            })
            .finally(() => this.setState({ loadingMentors: false }))
        })
    }

    selectMentor = (val) => {        
        const { mentors } = this.state
        let found =  mentors.find(({ id }) => id == val)
        this.setState({ selectedMentor: found })
    }

    onAmountInput = ({ target: { value } }) => {
        value = value.replace(/\D/, '')
        this.setState({ amount: value })
    }

    onTextInput = ({ target: { value } }) => {
        this.setState({ comment: value })
    }

    valid = () => {
        const { comment, amount } = this.state
        return (
            Number(amount) > 0 &&
            comment && (comment.length >= 4)
        )
    }

    submit = () => {

        const {
            selectedMentor,
            balance,
            amount,
            month,
            year,
            comment
        } = this.state

        if (!this.valid()) return        

        const payload = {
            mentor_id: selectedMentor.id,
            amount,
            payment_type: 'GENERAL_ONE_TIME',
            month,
            year,
            // user_subscription_id: null,
            // user_special_subscription_id: null,
            // agent_commission_id: null,
            percent: selectedMentor.percent,
            balance,
            status: 'ACTIVE',

            // months_to_charge: null,
            comment
        }

        this.setState({ loadingSubmit: true }, () => {
            commissions.createMentorCommission(payload)
            .then((res) => {
                console.log('res', res.data);
                this.props.getCommissions()
                alertPopup({ type: 'success', title: 'עמלת מנטור נוצרה בהצלחה', body: '' })
            })
            .catch((error) => {
                console.log('error. create mentor commission', error);
                alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
            })
        })
    }

    onClose = () => {
        this.props.popupStore.togglePopup(false)
    }

    render () {

        const {
            loadingSubmit,
            loadingMentors,
            mentors,
            selectedMentor,
            balance,
            year,
            month,
            amount,
            comment
        } = this.state
        return  (

            <Modal
                onCancel={this.onClose}
                visible={this.props.popupStore.popupType === 'oneTimeMentorCommission'}
                title={`יצירת עמלת מנטור`}
                footer={null}
                width='600px'
            >

            <div style={{ ...style.column }}>

                <Radio.Group value={balance === 'CREDIT'} onChange={this.toggleBalance} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                    <Radio.Button value={true}>זיכוי</Radio.Button>
                    <Radio.Button value={false}>חיוב</Radio.Button>
                </Radio.Group>

                <div style={{ ...style.formLine }}>
                    <span style={{ marginLeft: '6px' }}>{"מנטור: "}</span>

                    <div style={{ width: '70%', display: 'flex' }}>
                        {loadingMentors ? <Spin size="small" style={{ margin: '0 10px 0 0' }}/> :
                        <Select
                            value={selectedMentor.id}
                            defaultValue={selectedMentor.id}
                            onChange={this.selectMentor}
                            style={{ width: '170px' }}
                            disabled={loadingMentors}
                        >
                            {mentors.map(({ id, name }) => {
                                return (
                                    <Select.Option value={id} key={name}>
                                        {name}
                                    </Select.Option>
                                )
                            })}
                        </Select>}
                    </div>
                </div>

                <div style={{ ...style.formLine }}>
                    <span>{"עמלת מנטור:"}</span>
                    <div style={{ width: '70%', display: 'flex' }}> 
                        <Input value={amount} onChange={this.onAmountInput}/>
                    </div>
                </div>

                <div style={{ ...style.formLine }}>
                    <span>{"שנה:"}</span>
                    <div style={{ width: '70%', display: 'flex' }}>
                        <Select
                            value={year}
                            onChange={(year) => this.setState({ year })}
                            style={{ width: '85px' }}
                        >
                            {Array.from({ length: 15 }, (_, i) => 2017 + i).map((num) => {
                                return <Select.Option value={num - 2000} style={{ paddingInline: '0' }} key={num.toString()}>{num}</Select.Option>
                            })}
                        </Select>
                    </div>
                </div>

                <div style={{ ...style.formLine }}>
                    <span>{"חודש:"}</span>
                    <div style={{ width: '70%', display: 'flex' }}>
                        <Select
                            value={month}
                            onChange={(month) => this.setState({ month })}
                            style={{ width: '85px' }}
                        >
                            {new Array(12).fill(null).map((_, num) => {
                                return <Select.Option value={num + 1} style={{ paddingInline: '0' }} key={num.toString()}>{num + 1}</Select.Option>
                            })}
                        </Select>
                    </div>
                </div>

                
                <div style={{ ...style.formLine }}>
                    <span>{"פירוט:"}</span>
                    <div style={{ width: '70%', display: 'flex' }}>
                        <Input.TextArea value={comment} onChange={this.onTextInput} />
                    </div>
                </div>

                <Button
                    disabled={loadingSubmit || !this.valid()}
                    onClick={this.submit}
                    style={{ alignSelf: 'center' }}
                >
                    {loadingSubmit ? <Spin /> : "שמירה"}
                </Button>

            </div>
        </Modal>
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    formLine : { display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '15px' },
}

export default OneTimeMentorCommission